/**
 * @module client-api-base
 * @module_directory /modules/client/base
 * @module_path ui/components
 * @description Common UI modules
 * @recursive true
 * @ignore __tests__
 */
import React from "react";
import CircularProgress from "@material-ui/core/CircularProgress";
import { makeThemedStyles } from "./../../viewcomponents/utils";
import clsx from "clsx";
const useStyles = makeThemedStyles("Loader", (theme) => ({
  icon: {
    color: "#2B5D66",
    opacity: "0.8",
    width: "50px",
    heigth: "50px",
    position: "fixed",
    left: "50.4vw",
    top: "51.7vh",
  },
}));
const Loader = (props: { size?: string | number; class?: string }) => {
  const classes = useStyles();
  return (
    <CircularProgress
      className={clsx(classes.icon, props.class)}
      size={props.size}
    />
  );
};
export default Loader;
